import { configureStore } from '@reduxjs/toolkit';
import eventsReducer from './events/eventsSlice';
import formReducer from './forms/formSlice';

export const store = configureStore({
  reducer: {
    events: eventsReducer,
    form: formReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
